import axios from "axios";
import { Uploader } from "../../../handlers";
import { UploadSaveFailed } from "../../../handlers/errors";
class Uploads extends Uploader {
    constructor(sdk) {
        super(sdk);
        this.url = `${this.sdk.urls.baseAPIUrl}/template/publishers/import`;
    }
    /**
     * Accepts a single .xlsx file and creates and saves Optimization Templates based on its data
     * @param file: the file uploaded by the user. This file must be of type .xlsx
     * @param name: the name for the template
     * @param status: the status for the template (e.g., "200")
     * @param mediaType: the media type for the template (e.g., "VIDEO")
     * @returns: an array of created Optimization Templates
     * @throws: UploadSaveFailed, if an error occurs
     */
    async saveUpload({ file, name, status, mediaType, templateId }) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", name);
        formData.append("status", String(status));
        formData.append("mediaType", mediaType);
        // If templateId is provided, append it to update existing template
        if (templateId) {
            formData.append("template_id", templateId);
        }
        return axios
            .post(`${this.url}`, formData, {
            headers: {
                Accept: "application/json"
            }
        })
            .then(({ data: res }) => res.data)
            .catch((err) => {
            throw new UploadSaveFailed(err, "Failed to create optimization templates from template.");
        });
    }
}
export default Uploads;
//# sourceMappingURL=uploads.js.map